export const CATEGORIES_ORDER = ['gender and orientation', 'fantasy', 'personality', 'ethnicity', 'appearance', 'location'];
export const DEFAULT_TAGS = ['female', 'male'];
